var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-invite-email-component",
      on: {
        keyup: function ($event) {
          $event.stopPropagation()
          return _vm.keymap.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "modal-invite-email" }, [
        _c("div", { staticClass: "modal-invite-email-header" }, [
          _c("button", {
            staticClass: "modal-invite-email-back-button",
            on: { click: _vm.onClose },
          }),
          _c("p", { staticClass: "modal-invite-email-title" }, [
            _vm._v(_vm._s(_vm.$t("invite.email.title"))),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "modal-invite-email-body" },
          [
            _c(
              "div",
              { staticClass: "modal-invite-email-contents-form recive" },
              [
                _c("p", { staticClass: "modal-invite-email-contents-title" }, [
                  _vm._v(_vm._s(_vm.$t("invite.receiver"))),
                ]),
                _c("div", { staticClass: "modal-invite-email-input-wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    ref: "email",
                    staticClass: "modal-invite-email-input",
                    attrs: {
                      maxlength: "48",
                      placeholder: _vm.$t("common.email"),
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "modal-invite-email-add-button",
                      on: { click: _vm.add },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.add")))]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "modal-invite-email-contents-form recive-list" },
              [
                _c("p", { staticClass: "modal-invite-email-contents-title" }, [
                  _vm._v(_vm._s(_vm.$t("invite.list")) + " "),
                  _c("span", { staticClass: "modal-invite-email-count" }, [
                    _vm._v(_vm._s(_vm.invites.length)),
                  ]),
                ]),
                _c("div", { staticClass: "modal-invite-email-list-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "modal-invite-email-list-ps-wrapper" },
                    [
                      _c("perfect-scrollbar", [
                        _c(
                          "ul",
                          { staticClass: "modal-invite-email-list" },
                          _vm._l(_vm.invites, function (email, i) {
                            return _c(
                              "li",
                              {
                                key: i,
                                staticClass: "modal-invite-email-item",
                              },
                              [
                                _c(
                                  "p",
                                  { staticClass: "modal-invite-email-text" },
                                  [_vm._v(_vm._s(email))]
                                ),
                                _c("button", {
                                  staticClass:
                                    "modal-invite-email-remove-button",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeItem(i)
                                    },
                                  },
                                }),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "VButton",
              {
                staticClass: "modal-invite-email-send-button",
                on: { click: _vm.send },
              },
              [_vm._v(_vm._s(_vm.$t("invite.send")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }